// Reads the Django CSRF cookie so GraphQL POSTs can send it back in the
// X-CSRFToken header. Returns null when the cookie isn't set yet.
export const getCsrfToken = () => {
  const cookies = document.cookie.split(";");
  for (let cookie of cookies) {
    const [name, value] = cookie.trim().split("=");
    if (name === "csrftoken") {
      return value;
    }
  }
  return null;
};

export default getCsrfToken;
